import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { AccountBalanceService } from '@frontend/sports/account-balance/feature';
import { EpcotConfig, QuickBetConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { CurrencyPipe } from '@frontend/sports/common/core/feature/money';
import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { SportsThemedButtonDirective, SportsThemedIconButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { UserService } from '@frontend/sports/user/feature';
import { DsButton } from '@frontend/ui/button';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

import { BaseBalanceHeaderComponent } from '../../balance-header/base-balance-header.component';
import { QuickBetActions } from '../quick-bet-actions';
import { QuickBetHeaderService, QuickBetHeaderViewModel } from '../services/quick-bet-header.service';

@Component({
    selector: 'bs-quick-bet-header',
    templateUrl: './quick-bet-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-header.component.scss'],
    imports: [
        AsyncPipe,
        TrustPipe,
        DsButton,
        DsButtonIcon,
        IconCustomComponent,
        SportsThemedButtonDirective,
        CurrencyPipe,
        SportsThemedIconButtonDirective,
    ],
})
export class QuickBetHeaderComponent extends BaseBalanceHeaderComponent {
    protected readonly isUserBalanceEnabled: boolean;
    protected readonly isClearCtaTextEnabled: boolean;
    protected readonly buttonThemeInverse = { 'borgata-sports-2': true };
    protected readonly chevronThemeInverse: ThemeOptions<boolean> = { gamebookers: true, bwin: true };
    protected readonly vm$: Observable<QuickBetHeaderViewModel>;
    protected readonly accountBalance: Signal<number | null>;

    constructor(
        public sitecore: Sitecore,
        userService: UserService,
        epcotConfig: EpcotConfig,
        private quickBetConfig: QuickBetConfig,
        quickBetHeaderService: QuickBetHeaderService,
        accountBalanceService: AccountBalanceService,
        private store: Store,
    ) {
        super(userService, epcotConfig);

        this.isUserBalanceEnabled = this.quickBetConfig.isUserBalanceEnabled;
        this.isClearCtaTextEnabled = this.quickBetConfig.isClearCtaTextEnabled;
        this.vm$ = quickBetHeaderService.model$;
        this.accountBalance = toSignal(accountBalanceService.selectedWallet$.pipe(map((selectedWallet) => selectedWallet?.amount ?? null)), {
            initialValue: null,
        });
    }

    closeQuickBet(event: any): void {
        event.stopPropagation();
        this.store.dispatch(QuickBetActions.closeQuickbetUi());
    }
}
